<template>
  <div class="col">
    <BaseIndex
      ref="baseIndex"
      :modelNameSingular="modelNameSingular"
      :modelNamePlural="modelNamePlural"
      :loading="loading"
      :pageLoading="pageLoading"
      :table-headers="tableHeaders"
      :table-items="indexItems"
      :maskFields="maskFields"
      :infoHeaders="infoHeaders"
      @options-change="optionsChange"
      :serverItemsLength="totalItems"
      :loadOptions="options"
      :typeOperators="typeOperators"
      :enableCustomFilters="true"
      :containTopToolbar="false"
      :serverFields="serverFields"
      @filter-confirm-action="applyFilters"
    >
      <template slot="new" v-if="$can('create', $router.currentRoute.name)">
        <New
          @entry-created="entryCreated"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="filterText1">
        <v-card style="margin: 10px;">
          <v-text-field
            style="padding: 16px 16px;"
            v-model="code"
            label="Código"
            >
          </v-text-field>
        </v-card>
    </template>

      <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
        <Edit
          :entry="item"
          @entry-updated="entryUpdated"
          :readOnly="true"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
        <Edit
          :entry="item"
          @entry-updated="entryUpdated"
          :modelNameSingular="modelNameSingular"
          :isEdit="true"
        />
      </template>

      <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
        <Delete
          :entry="item"
          @entry-destroyed="entryDeleted"
          :modelNameSingular="modelNameSingular"
        />
      </template>
    </BaseIndex>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      code: null,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Descricao", align: "left", sortable: true, value: "description" },
        { text: "Movimentacao", align: "left", sortable: true, value: "move" },
        { text: "Financeiro", align: "left", sortable: true, value: "bill" },
        { text: "Propósito", align: "left", sortable: true, value: "purposeText" },
        { text: "Saída", align: "left", sortable: true, value: "out" },
        { text: "Verificado", align: "left", sortable: true, value: "verified" },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        // { field: 'price', mask: 'currency'},
        { field: 'move', mask: 'nice_boolean'},
        { field: 'bill', mask: 'nice_boolean'},
        { field: 'out', mask: 'nice_boolean'},
        { field: 'verified', mask: 'nice_boolean'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "CFOP"
    },
    modelNamePlural: {
      type: String,
      default: "CFOPs"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
    // this.loadServerEntries(true);
  },
  watch: {
    "code": function(newSearch) {
      if (this.code && this.code.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.loadServerEntries();
          }, 2000);
        }
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        this.loadServerEntries();
      }
    },
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: ALL_CFOPS_QUERY,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters,
              customFilters: {code: this.code},
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log(response.data);
          this.indexItems = response.data.adminContext.cfopsIndex.cfops; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.adminContext.cfopsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.adminContext.cfopsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.adminContext.cfopsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const ALL_CFOPS_QUERY = gql `
  query($input: IndexInputObject!) {
    adminContext {
      cfopsIndex(input: $input){
        count
        typeOperators
        serverFields 
        cfops {
          id
          code
          text
          description
          move
          bill
          purposeText
          out
          verified
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`
</script>

<style scoped></style>
